import React from "react";
import { Link } from "react-router-dom";
import CONSTANT from "../../../constant";
import { getDashboardLinks, deleteDashboardLink } from "../../../actions/MasterAction";

class DashboardLinkList extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      list: undefined,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.adminSection;
    this.loadList();
  }

  loadList = () => {
    getDashboardLinks().then((res: any) => {
      this.setState({ list: res?.result || [] });
    });
  };

  onDelete = (id: number) => {
    if (!window.confirm("Are you sure you want to delete this link?")) return;
    deleteDashboardLink(id).then((res: any) => {
      if (res?.status === CONSTANT.static.apiStatus.success) {
        this.loadList();
      } else {
        alert(res?.error || "Failed to delete");
      }
    });
  };

  render() {
    const { list } = this.state;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-12 my-3">
                <h1 className="page-title">Dashboard Document Links</h1>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-4">
                <Link
                  to={CONSTANT.component.adminAddDashboardLink.url}
                  className="btn btn-sm submit-button"
                >
                  <i className="fa fa-plus-circle mr-2" />
                  Add Document Link
                </Link>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mt-3">
                <div className="list-container">
                  <table className="table table-bordered table-hover">
                    <tbody>
                      <tr>
                        <th scope="col">S.No.</th>
                        <th scope="col">Title</th>
                        <th scope="col">File URL</th>
                        <th scope="col">Sort Order</th>
                        <th scope="col">Action</th>
                      </tr>
                      {list === undefined && (
                        <tr>
                          <td colSpan={5} className="text-center">
                            Loading...
                          </td>
                        </tr>
                      )}
                      {list !== undefined && list.length === 0 && (
                        <tr>
                          <td colSpan={5} className="text-center">
                            No records found
                          </td>
                        </tr>
                      )}
                      {list !== undefined &&
                        list.map((item: any, index: number) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.title}</td>
                            <td>
                              <a
                                href={item.fileUrl.startsWith("http") ? item.fileUrl : `${(process.env.REACT_APP_BASE_URL || "").replace("v1/", "").replace(/\/$/, "")}${item.fileUrl}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View / Download
                              </a>
                            </td>
                            <td>{item.sortOrder}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => this.onDelete(item.id)}
                              >
                                <i className="fa fa-trash" /> Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardLinkList;
